<template>
    <view-wrapper
      prefix="Print"
      name="Connector article"
      path="print-articles"
      :show-cancel="false"
      :loading="loading"
      loading-text="Getting connector article"
      back-text="Back to connector article list"
    >
      <wrapper class="mb-5" :check-for-child-focused="true">
        <g-input
          type="text"
          :readonly="true"
          label-placeholder="Article name"
          v-model="article.name"
        />
      </wrapper>
  
      <wrapper class="mb-5" :check-for-child-focused="true">
        <div class="flex justify-between">
          <p>Article data</p>
          <p
            class="font-bold underline cursor-pointer"
            @click="showAllArticleData = !showAllArticleData"
          >
            {{ showAllArticleData ? "Show only editable" : "Show all" }}
          </p>
        </div>
  
        <div class="article-data">
          <div
            v-for="(data, index) in article.articleData"
            v-show="(data.editable && !data.isExtra) || showAllArticleData"
            :key="`article-data--${index}`"
            class="grid grid-cols-5 gap-4"
          >
            <g-input
              :id="`article-key--${index}`"
              type="text"
              :readonly="true"
              :error="data.errors"
              label-placeholder="Key"
              v-model="data.key"
              :value="data.key"
              class="col-span-1"
              disabled
            />
            <g-input
              :id="`article-data--${index}`"
              :type="data.propertyType"
              label-placeholder=""
              v-model="data.data"
              @input="updateEditableData(data.key, $event)"
              :readonly="!data.editable"
              :editable="data.editable"
              :maxlength="findMaxLength(data)"
              :is-expandable="true"
              class="col-span-4"
            />
          </div>
        </div>
      </wrapper>
  
    </view-wrapper>
  </template>
  
  <script>
  import GInput from "../../components/forms/Input";
  // import PrintingComponent from "../../components/PrintingComponent";
//   import { getArticleDataVariables } from "../../utils/articleDataHelper";
  
  export default {
    components: {
      GInput,
      // PrintingComponent,
    },
    data: () => ({
      loading: false,
      article: {
        name: "",
        articleData: [],
        labels: [],
      },
      showAllArticleData: false,
      componentKey: 0,
    }),
    computed: {
      printArticle() {
        return this.article;
      },
    },
    methods: {
      async getArticle() {
        this.loading = true;
        const response = await this.$store.$api.get(
          `/api/connectors/${this.$route.params.connectorId}/articles/${this.$route.params.id}`
        );
        this.article = { ...response.data.data };
  
        // this.article.articleData = getArticleDataVariables(
        //   this.article.labels,
        //   [],
        //   this.article.articleData
        // );
  
        this.article.editableData = this.article.articleData.filter(
          a => a.editable
        );
  
        this.componentKey++;
        this.loading = false;
      },
      updateEditableData(key, data) {
        const variable = this.article.articleData.find(ad => ad.key === key);
        if (variable) {
          variable.data = data;
          variable.changed = true;
        }
        this.article.editableData = this.article.articleData.filter(
          a => a.editable
        );
      },
      findMaxLength(d) {
        if (d && d.propertySize) {
          return d.propertySize;
        }
        return 2000;
      },
    },
    async mounted() {
      await this.getArticle();
    },
  };
  </script>
  